import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    EditionCopyContentToEditionInput,
    CopyContentToEdition as CopyContentToEditionMutation,
    CopyContentToEditionVariables as CopyContentToEditionMutationVariables,
} from 'nutshell-graphql-types';

import COPY_CONTENT_TO_EDITION from '../mutations/copy-content-to-edition.graphql';

export function useCopyContentToEdition(): {
    copyContentToEdition: (arg1: EditionCopyContentToEditionInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [editionCopyContentToEdition, {loading, error}] = useMutation<
        CopyContentToEditionMutation,
        CopyContentToEditionMutationVariables
    >(COPY_CONTENT_TO_EDITION);

    return {
        copyContentToEdition: (input: EditionCopyContentToEditionInput) =>
            editionCopyContentToEdition({
                variables: {input},
            }).then(
                (result) =>
                    result &&
                    result.data &&
                    result.data.editionCopyContentToEdition &&
                    result.data.editionCopyContentToEdition.toEdition
            ),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
